import { useContext } from 'react'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step2Form } from '../../../containers/carkulka/Step2Form'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { StepsContent } from '../../../context/StepsContext'
import { insuranceParamsContext } from '../../../layouts/Wizard'

export const Step2 = () => {
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useContext(insuranceParamsContext)

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {!isLoadingData && paramsId && insuranceParams && 
          <StepsContent sx={{ minH: '3000px' }} step={2}>
            <Steps icon="car" />

            <InsuranceInfo />

            <Step2Form />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
